import { render, staticRenderFns } from "./biu-form.vue?vue&type=template&id=1bc32052&"
import script from "./biu-form.vue?vue&type=script&lang=ts&"
export * from "./biu-form.vue?vue&type=script&lang=ts&"
import style0 from "./biu-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports